import { useRef, useEffect, useState } from "react";
import { FaGoogle, FaEnvelope } from "react-icons/fa";
import { signInWithGoogle } from "../../services/Firebase";
import { useSelector } from "react-redux";
import SignUpWithEmail from "./SignUpWithEmail";

export default function SignUp({ onClose, onOpenLogin }) {

  const modalRef = useRef(null);
  const user = useSelector((state) => state.auth.user);

  const [signUpWithEmail, setSignUpWithEmail] = useState(false);

  // Close modal if user logs in
  useEffect(() => {
    if (user) onClose && onClose();
  }, [user, onClose]);

  // Close when clicking outside the modal
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const OnSignUpWithEmailClicked = () => {
    setSignUpWithEmail(true);
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm z-50">

      {/* Modal Content */}
      <div
        ref={modalRef}
        className="bg-[#0f0f0f] text-white w-[90%] max-w-md rounded-xl p-8 relative shadow-2xl animate-fadeIn"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300"
        >
          ✕
        </button>

        {/* Logo */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-red-500">RED VIDEO CHAT</h1>
          <p className="mt-2 text-lg">
            Sign up for <span className="text-yellow-400 font-semibold">FREE COINS!</span>
          </p>
        </div>

        {/* Google Button */}
        <button className="w-full flex items-center justify-center gap-3 bg-white text-black py-3 rounded-xl mb-4 font-medium hover:bg-gray-100 transition"
          onClick={signInWithGoogle}>
          <FaGoogle size={20} />
          Sign up with Google
        </button>

        {/* Email Button */}
        <button className="w-full flex items-center justify-center gap-3 bg-blue-500 py-3 rounded-xl mb-6 font-medium hover:bg-blue-600 transition"
          onClick={OnSignUpWithEmailClicked}>
          <FaEnvelope size={20} />
          Sign up with E-mail
        </button>

        {/* Login */}
        <p className="text-center text-sm">
          Do you have an account?{" "}
          <button
            onClick={() => {
              onClose && onClose();
              onOpenLogin && onOpenLogin();
            }}
            className="underline text-gray-300 hover:text-white"
          >
            Log In
          </button>
        </p>

        {/* Terms */}
        <p className="text-center text-xs mt-4 text-gray-400">
          By signing in you agree to our{" "}
          <a
            href="/privacy"
            className="underline text-gray-300 hover:text-white"
          >
            privacy policy
          </a>{" "}
          &{" "}
          <a
            href="/terms"
            className="underline text-gray-300 hover:text-white"
          >
            terms of service
          </a>.
        </p>
      </div>

      {signUpWithEmail && <SignUpWithEmail onClose={() => setSignUpWithEmail(false)} />}
    </div>
  );
}